<template>
  <el-dialog
    :title="!dataForm.isE ? '供应商基本信息' : '编辑供应商'"
    :close-on-click-modal="false"
    class="abow_dialog"
    width="50%"
    :visible.sync="visible">
    <el-form  size="mini" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px" class="user-info-dialog-form">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商账号" prop="venderLogin">
            <el-input v-model="dataForm.venderLogin"  placeholder="供应商账号" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="事业本" prop="venderCareerBody">
            <el-input v-model="dataForm.venderCareerBody" placeholder="事业本" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input v-model="dataForm.venderCode"  placeholder="供应商代码" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商名称" prop="venderName">
            <el-input v-model="dataForm.venderName" placeholder="供应商名称" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商简称" prop="venderAbbreviation">
            <el-input v-model="dataForm.venderAbbreviation" placeholder="企业性质" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商地址" prop="venderAdd">
            <el-input v-model="dataForm.venderAdd" placeholder="风险投资合伙人" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>         
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="联系人" prop="venderContacts">
            <el-input v-model="dataForm.venderContacts" placeholder="联系人" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="venderMail">
            <el-input v-model="dataForm.venderMail" placeholder="邮箱" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>         
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="供应商备用邮箱" prop="venderMailBak">
            <el-input v-model="dataForm.venderMailBak" placeholder="供应商备用邮箱" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="venderTel">
            <el-input v-model="dataForm.venderTel" placeholder="联系电话" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>         
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="数据来源" prop="venderSource">
            <el-input v-model="dataForm.venderSource" placeholder="数据来源" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" placeholder="备注" :disabled="!dataForm.isE ? true : false"></el-input>
          </el-form-item>         
        </el-col>
      </el-row>
      
    </el-form>
    <el-row>
      <el-col style="text-align: right;" v-if="!dataForm.isE ? false : true">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button type="primary" size="small" @click="dataFormSubmit()">确定</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import {selectSupplierById,updateSupplierById} from '@/controller/supplier'
  
  export default {
    data () {
      
      return {
        visible: false,
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: {
          targetId: 0,
          isE:'',
          venderCode: '',
          venderName : '',
          venderLogin : '',
          venderCareerBody : '',
          venderAbbreviation : '',
          venderAdd : '',
          venderContacts : '',
          venderMail : '',
          venderMailBak : '',
          venderTel : '',
          venderSource : '',
          remark : ''
        },
        dataRule: {
          venderCode: [
            { required: true, message: '供应商代码不可为空', trigger: 'change' }
          ],
          venderName: [
            { required: true, message: '供应商名称不可为空', trigger: 'change' }
          ],
        }
      }
    },
    methods: {
      init (row) {
        this.visible = true
        this.dataForm.targetId = row.targetId || 0
        this.dataForm.isE = row.isE
        this.$nextTick(() => {


            this.$refs['dataForm'].resetFields()
            // this.dataForm.tenantId = sessionStorage.getItem('tenantId')
            // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
            //this.dataForm.userTypeList = []
          
        selectSupplierById(
                  {id : this.dataForm.targetId}
           ).then(data => {
             if (data && data.code === '00') {
               this.dataForm = {...this.dataForm, ...data.body}
             }
           })
        
        })
      },
      
      // 表单提交
      dataFormSubmit () {
          
             
        // if(!sessionStorage.getItem('venderCode')){
        //     this.$message({message: '供应商代码不可为空22',type: 'error'})
        //     return
        // }
        // if(!sessionStorage.getItem('enterpriseName')){
        //     this.$message({message: '供应商名称不可为空',type: 'error'})
        //     return
        // }
          
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let params = {
              'id': this.dataForm.id || undefined,
              'venderCode': this.dataForm.venderCode,
              'venderName': this.dataForm.venderName,
              'venderLogin': this.dataForm.venderLogin,
              'venderCareerBody': this.dataForm.venderCareerBody,
              'venderAbbreviation': this.dataForm.venderAbbreviation,
              'venderAdd': this.dataForm.venderAdd,
              'venderContacts': this.dataForm.venderContacts,
              'venderMail': this.dataForm.venderMail,
              'venderMailBak': this.dataForm.venderMailBak,
              'venderTel': this.dataForm.venderTel,
              'venderSource': this.dataForm.venderSource,
              'remark': this.dataForm.remark
            }
            
              updateSupplierById(params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '修改成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }
              })
            
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>